import React, { Component, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Card,
} from "antd";
import { showDangerMessage, showSuccessMessage } from "../../utils/notification.util";
import { useTranslation } from 'react-i18next';
import { accountActivate, changePassword, sendOTP } from "../../services/auth.service";
import { GlobalContext } from "../../context/GlobalContext";
import { updateUser } from "../../services/user.service";
const { Title } = Typography;
const { Footer, Content } = Layout;

export default function Profile() {
  const { breadCrumb, user, setUser } = useContext(GlobalContext);
  const { t, i18n } = useTranslation();
  const [formData1, setFormData1] = useState({ email: '', fullName: ''});
  const [formData2, setFormData2] = useState({ password: '', newPassword: '', confirmPassword: ''});
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const navigate = useNavigate();
  const [disableOTPButton, setDisableOTPButton] = useState(false);
  const onFinish1 = (values) => {
    updateUser(user.uuid, values)
    .then((response) => {
      showSuccessMessage(`User updated successfully!`);
      // window.location.reload();
      setUser({
        ...user,
        fullName: values.fullName,
      });
    })
    .catch((error) => {
      showDangerMessage(`Error: ${error}`);
    });
  };
  const onFinishFailed1 = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onFinish2 = (values) => {
    changePassword(user?.email, values.password, values.otp)
    .then((response) => {
      showSuccessMessage(`Passowrd changed successfully!`);
      setDisableOTPButton(false);
      form2.setFieldsValue({ password: '', confirmPassword: '', otp: ''});
    })
    .catch((error) => {
      console.log("Error:", error);
      showDangerMessage(`Error: ${error}`);
    });
  };
  const onFinishFailed2 = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  useEffect(() => {
    setFormData1({ email: user?.email, fullName: user?.fullName});
    form1.setFieldsValue({ email: user?.email, fullName: user?.fullName});
  }, [user]);
  const handleOTPClick = () => {
    form2.validateFields().then(values => {
      setFormData2(prevData => ({ ...prevData, ...values }));
      setDisableOTPButton(true);
      sendOTP(user?.email)
      .then((response) => {
        showSuccessMessage(`OTP sent successfully, please check your email!`);
      })
      .catch((error) => {
        showDangerMessage(`Error: ${error}`);
        console.log("Error:", error);
      });
      setTimeout(() => {
        setDisableOTPButton(false);
        window.location.reload();
      }, 180000);
    }).catch((error) => {
      console.error('Validation failed:', error);
    });;
  };
  return (
    <div className="tabled">
        <Row gutter={[24, 0]} >
          <Col xs="12" xl={12}>
            <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                style={{padding: '20px'}}
                title=""
              >
              <Form
                form={form1}
                onFinish={onFinish1}
                onFinishFailed={onFinishFailed1}
                layout="vertical"
                className="row-col"
                key={JSON.stringify(formData1)}
                initialValues={formData1}>
                  <Title className="mb-15">Edit Details</Title>
                <Form.Item
                  className="username"
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input placeholder="Email" readOnly disabled/>
                </Form.Item>
                <Form.Item
                  className="username"
                  label="Full Name"
                  name="fullName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input placeholder="Full Name" />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                  >
                    {t("Update")}
                  </Button>
                </Form.Item>
                </Form>
            </Card>
            <Card>
                <Title className="mb-15">Reset Password</Title>
                <Form
                form={form2}
                onFinish={onFinish2}
                onFinishFailed={onFinishFailed2}
                layout="vertical"
                className="row-col"
                key={JSON.stringify(formData2)}
                initialValues={formData2}>
                {/* <Form.Item
                  className="username"
                  label="Current Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                    {
                      min: 5,
                      message: 'Password must be at least 5 characters!',
                    },
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>
                <Form.Item
                  className="username"
                  label="New Password"
                  name="newPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                    {
                      min: 5,
                      message: 'Password must be at least 5 characters!',
                    },
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>

                <Form.Item
                  className="username"
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input confirm password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                  >
                    {t("Change Password")}
                  </Button>
                </Form.Item> */}
                <Form.Item
                className="username"
                label="New Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                  {
                    min: 5,
                    message: 'Password must be at least 5 characters!',
                  },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item
                className="username"
                label="Confirm Password"
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: "Please input confirm password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Passwords do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item>
                <Button onClick={() => handleOTPClick()} disabled={disableOTPButton}>Get OTP</Button>
              </Form.Item>
              {/* <p>{otpMessage}</p> */}
              { disableOTPButton &&
              <Form.Item
                className="username"
                label="Check your email for OTP"
                name="otp"
                rules={[
                  {
                    required: true,
                    message: "Please input OTP from email!",
                  },
                ]}
              >
                <Input placeholder="OTP from email" />
              </Form.Item>
              }
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  disabled={!disableOTPButton}
                >
                  Change Password
                </Button>
              </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
  );
}